import queryString from "query-string";
import { getCookie } from "../utils/helpers";

export const objectToQueryString = (obj, options = {}) =>
  queryString.stringify(obj, {
    arrayFormat: "bracket",
    skipEmptyString: true,
    ...options,
  });

export const defaultConfig = {
  SMSBaseUrl: "",
  headers: (contentType) => ({
    "content-typ": contentType,
    Accept: "application/json",
    ...(getCookie("user_token")
      ? { "x-access-token": `${getCookie("user_token")}` }
      : {}),
  }),
  error: {
    code: "INTERNAL_ERROR",
    message:
      "Something went wrong. Please check your internet connection or contact our support.",
    status: 503,
    data: {},
  },
};
